import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/crateStock'

const crateStock = axios.create({
  baseURL
})

interceptorsSetup(crateStock)

export default class Stock {
  static async get (stockQuery) {
    const result = await crateStock.get('/' + stockQuery.siteId, {
      params:
      {
        date: stockQuery.date,
        statuses: stockQuery.statuses
      }
    })
    return result.data
  }

  static async getWorld (stockQuery) {
    const result = await crateStock.get('/world/stock', {
      params:
      {
        date: stockQuery.date,
        plants: stockQuery.plants
      }
    })
    return result.data
  }
}
